export class FutureMedOrderOptions {
  medOrderDate: Date;
  clinicId: number;
  clinicName: string;

  constructor(medOrderDate?: Date, clinicId?: number, clinicName?: string);
  constructor(medOrderDate: Date, clinicId: number, clinicName: string) {
    this.medOrderDate = medOrderDate;
    this.clinicId = clinicId;
    this.clinicName = clinicName;
  }
}
